import {PublicKey, Transaction} from "@solana/web3.js";
import {connection} from "../constants/factory";

export async function updateTx(tx: Transaction, feePayer: PublicKey) {
  tx.recentBlockhash = (await connection.getLatestBlockhash('max')).blockhash;
  tx.feePayer = feePayer;
}
